import client from '../request'

//get all
const getAll = '/tracking-companies'

//get by id
const get = (id) => {
  return `/tracking-companies/${id}`
}

const toRow = (data) => {
  if (data?.data?.length > 0) {
    return data.data.map((element) => {
      return {
        ...element,
        key: element.id
      }
    })
  }

  return []
}

const toPaginate = (data) => {
  return {
    total: data?.meta?.total ?? 0
  }
}

const TrackingCompanyService = {
  getAll,
  get,
  toRow,
  toPaginate
}

export default TrackingCompanyService
